// ************************************ //
// Every page - framework functionality //
// ************************************ //

import $ from 'jquery';
import 'Vue/vue-router';

import { NavLoad } from 'App/nav/load';
NavLoad.init();

import { Social as SocialShare } from 'App/social/share';
SocialShare.init();

import { Cookie } from 'App/cookie/cookie';
Cookie.init();

import { BackToTop } from 'App/back-to-top/back-to-top';
BackToTop.init();

import { JumpLinks } from 'App/jumplinks/jumplinks';
JumpLinks.init();

import * as CoreUtil from 'Util/core';
$(document).on('click', 'a[data-anchor]', function (event) {
    const href = this.getAttribute('href') || '';
    const hash = href.indexOf('#') > -1 ? href.split('#')[1] : '';
    if (!hash) {
        return;
    }

    const $target = $('#' + hash.replace(/([^\w-])/g, '\\$1'));
    if ($target.length) {
        event.preventDefault();
        const navHeight = $('.js-navigation').outerHeight() || 0;
        CoreUtil.scrollToElm($target, navHeight);
    }
});

// Publish resize and scroll events for other modules to use
import { publish } from 'Util/pubsub';
import { throttle } from 'Util/throttle';

const $window = $(window);
$window.on(
    'resize',
    throttle(() => publish('/window/resize'), 250),
);
$window.on('scroll', () => publish('/window/scroll'));

// ********************************************************* //
//                      Controls                             //
// ********************************************************* //

// Google Maps
if (document.querySelector('.js-google-map')) {
    import(
		/* webpackChunkName: "GoogleMap" */ 'Controls/control.google-map'
    ).then(({ GoogleMap }) => {
        GoogleMap.init();
    });
}

// Locations List
if (document.querySelector('.js-locations-list__map')) {
    import(
		/* webpackChunkName: "LocationsList" */ 'Controls/control.locations-list'
    ).then(({ LocationsList }) => {
        LocationsList.init();
    });
}

// Rich Text Editor
if (document.querySelector('.c-rte')) {
    import(/* webpackChunkName: "Rte" */ 'Controls/control.rte').then(
        ({ Rte }) => {
            Rte.init();
        },
    );
}

document.addEventListener('DOMContentLoaded', () => {

    // Gallery Grid
    if (document.querySelectorAll('.c-home-hero')) {
        import(
		/* webpackChunkName: "HomeHeroRotator" */ 'App/homehero/homehero'
        ).then(({ HomeHeroRotator }) => {
            HomeHeroRotator.init();
        });
    }

    // Gallery Grid
    if (document.querySelectorAll('.js-gallery-grid')) {
        import(
		/* webpackChunkName: "GalleryGrid" */ 'Controls/control.gallery-grid'
        ).then(({ GalleryGrid }) => {
            const $galleryGrids = $('.js-gallery-grid');
            GalleryGrid.init($galleryGrids);
        });
    }

    // Gallery Rotator
    if (document.querySelectorAll('.js-gallery-rotator')) {
        import(
		/* webpackChunkName: "GalleryRotator" */ 'Controls/control.gallery-rotator'
        ).then(({ GalleryRotator }) => {
            const $galleryRotators = $('.js-gallery-rotator');
            GalleryRotator.init($galleryRotators);
        });
    }

    // Logo Carousel
    if (document.querySelectorAll('.js-logo-carousel')) {
        import(
		/* webpackChunkName: "LogoCarousel" */ 'Controls/control.logo-carousel'
        ).then(({ LogoCarousel }) => {
            const $logoCarousels = $('.js-logo-carousel');
            LogoCarousel.init($logoCarousels);
        });
    }

    // Pathway Carousel
    if (document.querySelectorAll('.js-pathway-carousel')) {
        import(
		/* webpackChunkName: "PathwayCarousel" */ 'Controls/control.pathway-carousel'
        ).then(({ PathwayCarousel }) => {
            const $pathwayCarousels = $('.js-pathway-carousel');
            PathwayCarousel.init($pathwayCarousels);
        });
    }

    // Testimonials Rotator
    if (document.querySelectorAll('.js-testimonials-rotator')) {
        import(
		/* webpackChunkName: "TestimonialsRotator" */ 'Controls/control.testimonials-rotator'
        ).then(({ TestimonialsRotator }) => {
            const $testimonialsRotators = $('.js-testimonials-rotator');
            TestimonialsRotator.init($testimonialsRotators);
        });
    }

    // Promotion Rotator
    if (document.querySelectorAll('.js-promotion-carousel')) {
        import(
		/* webpackChunkName: "PromotionCarousel" */ 'Controls/control.promotion-carousel'
        ).then(({ PromotionCarousel }) => {
            const $promotionCarousels = $('.js-promotion-carousel');
            PromotionCarousel.init($promotionCarousels);
        });
    }

});

// ********************************************************* //
//                      Utilities                            //
// ********************************************************* //

// Expand and Collapse
if (document.querySelector('.js-expand-collapse')) {
    import(
		/* webpackChunkName: "ExpandCollapse" */ 'App/expand-collapse/expand-collapse'
    ).then(({ expandCollapse }) => {
        expandCollapse.init();
    });
}

// Select Link
if (document.querySelector('.js-select-link')) {
    import(
		/* webpackChunkName: "SelectLink" */ 'App/select-link/select-link'
    ).then(({ selectLink }) => {
        selectLink.init();
    });
}

// Modal
if (document.querySelector('.js-modal')) {
    import(/* webpackChunkName: "Modal" */ 'App/modal/modal').then(
        ({ modal }) => {
            modal.init();
        },
    );
}

// Scroll Appear
if (document.querySelector('.js-scroll-appear')) {
    import(
		/* webpackChunkName: "ScrollAppear" */ 'App/scroll-appear/scroll-appear'
    ).then(({ scrollAppear }) => {
        scrollAppear.init();
    });
}

// Umbraco Forms
if (document.querySelector('.js-umbraco-form')) {
    import(/* webpackChunkName: "UmbracoForms" */ 'App/form/form.umbraco').then(
        ({ UmbracoForms }) => {
            UmbracoForms.init();
        },
    );
}

// Video Player
if (document.querySelector('.js-video-player')) {
    import(/* webpackChunkName: "VideoPlayer" */ 'App/video/video.player').then(
        ({ VideoPlayer }) => {
            VideoPlayer.init();
        },
    );
}

// Video Gallery
if (document.querySelector('.js-video-gallery')) {
    import(/* webpackChunkName: "VideoGallery" */ 'App/video/gallery').then(
        ({ videoGallery }) => {
            videoGallery.init();
        },
    );
}

// Event calendar add
if (document.querySelector('.js-calendar-link')) {
    import(/* webpackChunkName: "Calendar" */ 'App/event/calendar').then(
        ({ Calendar }) => {
            Calendar.init();
        },
    );
}

// Flyout
$(document).on('click', '[data-flyout-toggle]', function () {
    const flyoutName = $(this).attr('data-flyout-toggle');
    const $flyout = $('[data-flyout-panel="' + flyoutName + '"]');

    if ($flyout.length) {
        $flyout.toggleClass('is-active');

        if ($flyout.hasClass('is-active')) {
            // Prepend backdrop as the first child of <body> if not already present
            if (!$('body').find('.c-filters-backdrop').length) {
                $('body').prepend('<div class="c-filters-backdrop"></div>');
            }
        } else {
            // Remove backdrop if flyout is not active
            $('body').find('.c-filters-backdrop').remove();
        }
    }
});

// Remove is-active from flyout when clicking backdrop
$(document).on('click', '.c-filters-backdrop', function () {
    const $flyout = $('[data-flyout-panel].is-active');
    $flyout.removeClass('is-active');
    $(this).remove();
});
